import { Platform } from 'react-native';
import Toast from 'react-native-toast-message';

import { playSound } from '../../utils/sound';

const TOAST_BASE = {
	visibilityTime: 10_000,
	topOffset: Platform.OS === 'web' ? 56 : 12,
	position: 'top' as const,
};

export function showGameBroadcastToast(
	type:
		| 'broadcastJackpot'
		| 'broadcastVegas'
		| 'broadcastTournament'
		| 'broadcastWhiskey'
		| 'rewardBonus'
		// Plain-text renderer, already registered in globalBroadcastToastConfig. Used
		// for messages that have no artwork of their own, such as being kicked.
		| 'error',
	text1: string,
	props?: Record<string, unknown>,
	text2?: string,
) {
	if (process.env.NODE_ENV !== 'production') {
		console.log('[GameBroadcast] Toast.show', { type, text1: text1.slice(0, 80) });
	}

	// v1 init.service plays ToastError on showPlayerKicked, the only 'error' user here.
	if (type === 'error') playSound('ToastError');

	Toast.show({
		...TOAST_BASE,
		type,
		text1,
		text2,
		props,
	});
}

const ACHIEVEMENT_TOAST_VISIBILITY_MS = 5_000;

export function showAchievementUnlockedToast(text1: string, displayTier: number, iconKey?: string) {
	Toast.show({
		...TOAST_BASE,
		visibilityTime: ACHIEVEMENT_TOAST_VISIBILITY_MS,
		type: 'achievementUnlocked',
		text1,
		props: { displayTier, iconKey },
	});
}
